import { ITickerMessageSegment, TickerServiceEvent } from "@netent/origin";
import { IPlayUIState } from "@netent/playui";
import { ListenerCreator } from "../../types";

const show = () => (
  message: ITickerMessageSegment[] | string
): IPlayUIState => ({
  ticker: {
    animate: false,
    enabled: true,
    message
  }
});

const hide = () => (): IPlayUIState => ({
  ticker: {
    enabled: false
  }
});

export const listeners = new Map<TickerServiceEvent, ListenerCreator>([
  ["show", show],
  ["hide", hide]
]);
